(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD
    define(['torso/modules/NestedModel'], factory);
  } else if (typeof exports === 'object') {
    // Node, CommonJS-like
    module.exports = factory(require('backbone-torso/modules/NestedModel'));
  } else {
    throw 'Only AMD and CommonJS imports are supported.';
  }
}(this, function (TorsoNestedModel) {
  'use strict';

  /**
   * Model representing a printable item.
   * Sets the idAttribute to 'vecnaId' since Printable is identified by its unique vecnaId.
   * @class PrintableModel
   * @constructor
   * @extends Torso.NestedModel
   */
  return TorsoNestedModel.extend({
    idAttribute: 'vecnaId'
  });
}));
